import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { space } }) => css`
    background: white;
    width: 448px;
    padding: ${space.s30};
  `}
`;
